import { render, staticRenderFns } from "./WiringDialog.vue?vue&type=template&id=2a6277b1&scoped=true&"
import script from "./WiringDialog.vue?vue&type=script&lang=js&"
export * from "./WiringDialog.vue?vue&type=script&lang=js&"
import style0 from "./WiringDialog.vue?vue&type=style&index=0&id=2a6277b1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6277b1",
  null
  
)

export default component.exports